<template>
  <div>
    <v-toolbar :elevation="expanded ? 0 : 1" :extended="expanded" :extension-height="expanded ? 100 : 0">
      <v-row no-gutters align="center">
        <v-col cols="auto">
          <v-layout row class="display-1 ml-2">
            <div id="font">Simples</div>
            <div id="font" class="primary--text">Medic</div>
          </v-layout>
        </v-col>
        <v-divider vertical class="ml-6" v-if="expanded" />
        <v-col cols="auto" v-if="expanded">
          <div class="d-flex align-center px-4 py-2">
            <v-avatar size="40" class="mr-3">
              <v-img src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"></v-img>
            </v-avatar>
            <div>
              <div class="font-weight-bold">{{ dadosPaciente.nomePaciente }}</div>
              <div class="d-flex mt-1">
                <v-chip small color="grey darken-3" text-color="white" class="mr-1">
                  <v-icon x-small left>mdi-label</v-icon>
                  {{ dadosPaciente.atendimento }}
                </v-chip>
                <v-chip small color="blue darken-3" text-color="white">
                  <v-icon x-small left>confirmation_number</v-icon>
                  {{ dadosPaciente.tipoAtendimento }}
                </v-chip>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-spacer />

      <div>
        <v-card v-if="user && user.tecnico" class="rounded-xl" outlined>
          <v-list-item>
            <v-icon class="mr-2">person</v-icon>
            <v-list-item-content>
              <v-list-item-title v-text="user ? nomeFormatado(user.nome) : ''" />
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <v-card v-else outlined class="rounded-xl">
          <v-list-item>
            <v-icon class="mr-2">person</v-icon>
            <v-list-item-content>
              <v-list-item-title v-text="user ? 'Dr(a). ' + nomeFormatado(user.nome) : ''" />
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>

      <v-btn title="Ajuda" text icon color="primary" @click="retornarHelp()">
        <v-icon title="Ajuda">info</v-icon>
      </v-btn>

      <v-btn title="Logout" text icon color="primary" @click="logout()">
        <v-icon v-if="user && user.tecnico" title="Logout">logout</v-icon>
        <v-icon v-else title="Logout">power_settings_new</v-icon>
      </v-btn>

      <!-- Área Expandida Otimizada -->
      <template v-slot:extension>
        <v-card flat class="mx-2" height="100" style="width: 100%" v-show="expanded">
          <v-divider />
          <v-row dense class="py-2">
            <!-- Linha 1 - Dados Secundários -->
            <v-col cols="12" sm="6" md="4">
              <div class="text-body-2">
                <span class="grey--text">Nasc:</span> {{ dadosPaciente.dataNascimento }}
                <span class="mx-1">•</span>
                <span class="grey--text">Idade:</span> {{ dadosPaciente.idade }}
              </div>
              <div class="text-body-2 mt-1">
                <span class="grey--text">Convênio:</span> {{ dadosPaciente.convenio }}
                <span class="mx-1">•</span>
                 <span class="grey--text">Sexo:</span> {{ dadosPaciente.sexo }}
              </div>
            </v-col>

            <!-- Linha 1 - Documentos -->
            <v-col cols="12" sm="6" md="4">
              <div class="text-body-2">
                <span class="grey--text">CPF:</span> {{ dadosPaciente.CPF }}
              </div>
              <div class="text-body-2 mt-1">
                <span class="grey--text">RG:</span> {{ dadosPaciente.RG }}
              </div>
            </v-col>

            <!-- Linha 2 - Dados Adicionais -->
            <v-col cols="12" sm="6" md="4">
              <div class="d-flex">
                <div class="text-body-2 mr-4">
                  <span class="grey--text">Cidade:</span> {{ dadosPaciente.cidade }}
                </div>
                <div class="text-body-2">
                  <span class="grey--text">Solicitante:</span> {{ dadosPaciente.solicitante }}
                </div>
              </div>
            </v-col>

            <!-- Lista ajustada para caber no espaço -->
            <v-col cols="12" class="py-0">
              <v-list dense disabled class="py-0" style="max-height: 48px; overflow: hidden;">
                <v-list-item-group v-model="colorItem" :color="items[mItem].color">
                  <v-list-item link class="px-2" style="min-height: 40px;">
                    <v-list-item-icon class="mr-2">
                      <v-icon small v-text="items[mItem].icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-caption">
                        {{ items[mItem].text }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-show="items[mItem].badge" class="ml-2">
                      <v-avatar size="20" class="amber lighten-2">
                        {{ items[mItem].badge }}
                      </v-avatar>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card>
      </template>
    </v-toolbar>
    <v-divider v-if="!expanded" />
    <SideBar @selecionado="onIconClicked" />
    <SideBarRight :initialMini="sideBarMini" @selecionado="onIconClickedLeft" />
    <HomePage  class="animated fadeInRight" v-show="indexSelect == 0 && (!user || !user.tecnico)" />
    <HomeMedico v-show="indexSelect == 1 || (user && user.tecnico)" />
    <laudoClinico v-if="indexSelect == 2"></laudoClinico>
    <pacientes @fechar="indexSelect = 0" v-if="indexSelect == 10" />
    <atendimentos @fechar="indexSelect = 0" v-if="indexSelect == 11" />
    <modeloProntuario @fechar="indexSelect = 0" v-if="indexSelect == 12" />
    <prontuarioRetorno  v-if="indexSelect == 3" />

  </div>
</template>

<script>
import SideBar from '../components/SideBar.vue'
import SideBarRight from '../components/SideBarLeft.vue'
import HomePage from '../components/medico/homePage.vue'
import LaudoClinico from '../components/medico/laudoClinico.vue'
import HomeMedico from '../views/HomeMedico.vue'
import Atendimentos from '../components/medico/atendimentos.vue'
import ModeloProntuario from '../components/medico/modeloProntuario.vue'
import Pacientes from '../components/medico/pacientes.vue'
import ProntuarioRetorno from '../components/medico/prontuarioRetorno.vue'

import { EventBus } from '../main'

export default {
  name: 'MedicoDashBoard',
  props: {
    tempoAtd: {
      type: String,
      default: '00:00:00'
    },
    mFicha: {
      type: Object
    },
    consultasPaciente: {
      type: Array
    }
  },
  data () {
    return {
      sideBarMini: false,
      indexSelect: 0,
      expanded: false,
      colorItem: 0,
      mItem: 0,
      dadosPaciente: {
        nomePaciente: '',
        atendimento: '',
        tipoAtendimento: '',
        dataNascimento: '',
        idade: '',
        sexo: '',
        CPF: '',
        RG: '',
        convenio: '',
        cidade: '',
        solicitante: ''
      },
      user: null,
      items: [
        {
          'text': 'Resumo Clínico',
          'icon': 'book',
          'id': 1,
          'badge': 0,
          'disabled': false,
          'color': '#00BCD4'
        },
        {
          'text': 'Prontuário',
          'icon': 'description',
          'id': 2,
          'badge': 0,
          'disabled': false,
          'color': '#1E88E5' /* Turquesa médio */
        },
        {
          'text': 'Receituário',
          'icon': 'assignment_turned_in',
          'id': 4,
          'badge': 0,
          'disabled': false,
          'color': '#FFA07A' /* Salmão forte */
        },
        {
          'text': 'Solicitação',
          'icon': 'pending_actions',
          'id': 6,
          'badge': this.exigeAludo,
          'disabled': false,
          'color': '#7B68EE' /* Azul ardósia médio */
        },
        {
          'text': 'Laudo',
          'icon': 'post_add',
          'badge': 0,
          'id': 7,
          'disabled': false,
          'color': '#32CD32' /* Verde lima */
        },
        {
          'text': 'Relatório',
          'icon': 'note',
          'id': 8,
          'badge': 0,
          'disabled': false,
          'color': '#9370DB' /* Roxo médio */
        }
      ]
    }
  },
  methods: {
    nomeFormatado (str) {
      var arr = str.split(' ')
      if (arr[1] != null) {
        var preposicao = arr[1].toLowerCase()
        if (
          preposicao == 'de' ||
          preposicao == 'da' ||
          preposicao == 'das' ||
          preposicao == 'do' ||
          preposicao == 'dos'
        ) {
          preposicao = true
        } else {
          preposicao = false
        }
      }
      return arr.slice(0, preposicao ? 3 : 2).join(' ')
    },
    onIconClicked (index) {
      if (index == 0) {
        this.sideBarMini = false
      } else {
        this.sideBarMini = true
      }
      this.indexSelect = index
    },
    onIconClickedLeft (index) {
      index += 10
      this.indexSelect = index
    },
    logout () {
      EventBus.$emit('logout', 'exit')
    },
    retornarHelp () {
      EventBus.$emit('retornarHelp', 'get')
    }
  },
  components: {
    SideBar,
    HomePage,
    HomeMedico,
    SideBarRight,
    'atendimentos': Atendimentos,
    'pacientes': Pacientes,
    'modeloProntuario': ModeloProntuario,
    'laudoClinico': LaudoClinico,
    'prontuarioRetorno': ProntuarioRetorno

  },
  mounted () {
    this.user = this.$store.getters.usuario
    EventBus.$on('paciente-selecionado', (paciente) => {
      console.log('Paciente selecionado:', paciente)
      this.dadosPaciente = {
        nomePaciente: paciente.nome || '',
        atendimento: paciente.atendimento || '',
        tipoAtendimento: paciente.tipoAtendimento || '',
        dataNascimento: paciente.dataNascimento || '',
        idade: paciente.idade || '',
        sexo: paciente.sexo || '',
        CPF: paciente.CPF || '',
        RG: paciente.RG || '',
        convenio: paciente.convenio || '',
        cidade: paciente.cidade || '',
        solicitante: paciente.solicitante || ''
      }
      this.expanded = true
    })
    EventBus.$on('item-selecionado', (item) => {
      this.mItem = item
    })
    EventBus.$on('item-exit', () => {
      this.expanded = false
      this.dadosPaciente = {
        nomePaciente: '',
        atendimento: '',
        tipoAtendimento: '',
        dataNascimento: '',
        idade: '',
        sexo: '',
        CPF: '',
        RG: '',
        convenio: '',
        cidade: '',
        solicitante: ''
      }
    })
  },
  beforeDestroy () {
    EventBus.$off('paciente-selecionado')
    EventBus.$off('item-selecionado')
    EventBus.$off('item-exit')
  }
}
</script>

<style>
.space {
  margin-left: -100px;
  margin-right: -100px;
}
</style>
